const cartTotal = document.querySelector('[data-header-cart-total]');
const cartCount = document.querySelector('[data-header-cart-count]');

function showCartElement(element) {
  if (element.classList.contains('hide')) element.classList.remove('hide');
}

function hideCartElement(element) {
  if (!element.classList.contains('hide')) element.classList.add('hide');
}

console.log('Setting cart mutation observer');
const observer = new MutationObserver((mutation, observer) => {
  //   console.log('Cart total changed');
  if (cartCount.innerText > 0) {
    // console.log('Showing cart total');
    showCartElement(cartTotal);
    showCartElement(cartCount);
  }
  if (cartTotal.innerText == '$0.00' && !cartTotal.classList.contains('hide')) {
    // console.log('Hiding cart total');
    hideCartElement(cartTotal);
    hideCartElement(cartCount);
  }
});

observer.observe(cartTotal, {
  attributes: false,
  childList: true,
  subtree: false
});
